import * as React from 'react';
import { AsyncStorage, Text, TextInput, View, Image } from 'react-native';
import { Container, Header, Content, Form, Item, Input, Button, Thumbnail, Footer } from 'native-base';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'expo-constants';

import RootDrawer from "../DashboardScreen/index.js";
import { Styles, Layouts } from "../../utils/index.js";

import * as Analytics from 'expo-firebase-analytics';
//import {db, analytics} from '../../utils/ipa.js';

const AuthContext = React.createContext();

function SplashScreen() {
  return (
    <View>
      <Text>Loading...</Text>
    </View>
  );
}

function HomeScreen() {
  const { signOut } = React.useContext(AuthContext);

  return (
    <View>
      <Text>Signed in!</Text>
      <Button title="Sign out" onPress={signOut} />
    </View>
  );
}


function SignInScreen() {
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');

    const { signIn } = React.useContext(AuthContext);

  //testing analytics
  // try {
  //   Analytics.logEvent('login');
  // } catch (error) {
  //   alert(error); 
  // }

  // try {
  //   Analytics.logEvent('exception', {description: "error", fatal:false})
  // } catch (error) {
  //   alert(error);
  // }

  return (
    // <View>
    //   <TextInput
    //     placeholder="Username"
    //     value={username}
    //     onChangeText={setUsername}
    //   />
    //   <TextInput
    //     placeholder="Password"
    //     value={password}
    //     onChangeText={setPassword}
    //     secureTextEntry
    //   />
    //   <Button title="Sign in" onPress={() => signIn({ username, password })} />
    // </View>
    <Container>
        <Header>
          <Text>Header</Text>
        </Header>
        <Content contentContainerStyle={{ flexGrow:1, flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
            <Form style={{minWidth:300}}>
                <Item>
                    <Input placeholder="Username" onChangeText={setUsername}  />
                </Item>
                <Item last>
                    <Input placeholder="Password" onChangeText={setPassword} />
                </Item>
                <Button rounded style={{backgroundColor:Styles.colorPalette.mainColor, justifyContent:"center", alignItems:"center", marginTop: 10 }} 
                        onPress={() => signIn({ username, password })}>
                    <Text style={{color:Styles.colorPalette.White}}>Sign On</Text>
                </Button>
            </Form>
        </Content>
        <Footer style={Styles.loginScreen.footer}>
            <Text>Version: {Constants.manifest.version}</Text>
        </Footer>
    </Container>
  );
}

const Stack = createStackNavigator();

export default function SignOn({ navigation }) {
  const [state, dispatch] = React.useReducer(
    (prevState, action) => {
      switch (action.type) {
        case 'RESTORE_TOKEN':
          return {
            ...prevState,
            userToken: action.token,
            isLoading: false,
          };
        case 'SIGN_IN':
          return {
            ...prevState,
            isSignout: false,
            userToken: action.token,
          };
        case 'SIGN_OUT':
          return {
            ...prevState,
            isSignout: true,
            userToken: null,
          };
      }
    },
    {
      isLoading: true,
      isSignout: false,
      userToken: null,
    }
  );

  React.useEffect(() => {
    // Fetch the token from storage then navigate to our appropriate place
    const bootstrapAsync = async () => {
      let userToken;

      try {
        userToken = await AsyncStorage.getItem('userToken');
      } catch (e) {
        // Restoring token failed
      }

      // After restoring token, we may need to validate it in production apps

      // This will switch to the App screen or Auth screen and this loading
      // screen will be unmounted and thrown away.
      dispatch({ type: 'RESTORE_TOKEN', token: userToken });
    };

    bootstrapAsync();
  }, []);

  const authContext = React.useMemo(
    () => ({
      signIn: async data => {
        // In a production app, we need to send some data (usually username, password) to server and get a token
        // We will also need to handle errors if sign in failed
        // After getting token, we need to persist the token using `AsyncStorage`
        // In the example, we'll use a dummy token

        dispatch({ type: 'SIGN_IN', token: 'dummy-auth-token' });
      },
      signOut: () => dispatch({ type: 'SIGN_OUT' }),
      signUp: async data => {
        // In a production app, we need to send user data to server and get a token
        // We will also need to handle errors if sign up failed
        // After getting token, we need to persist the token using `AsyncStorage`
        // In the example, we'll use a dummy token

        dispatch({ type: 'SIGN_IN', token: 'dummy-auth-token' });
      },
    }),
    []
  );

  const logo = require('../../assets/HFCLogo.png')

  return (
    <AuthContext.Provider value={authContext}>
      <NavigationContainer>
        <Stack.Navigator>
          {state.isLoading ? (
            // We haven't finished checking for the token yet
            <Stack.Screen name="Splash" component={SplashScreen} />
          ) : state.userToken == null ? (
            // No token found, user isn't signed in
            <Stack.Screen
              name="SignIn"
              //component={SignInScreen}
              component={RootDrawer}
              options={{
                title: 'Heroes From Cupid',
                headerTitleAlign: "center",
                headerShown: false,
                headerStatusBarHeight: 100,
            // When logging out, a pop animation feels intuitive
                animationTypeForReplace: state.isSignout ? 'pop' : 'push',
                headerLeftContainerStyle: {flexGrow:1, flexDirection:"row", alignItems:"center", justifyContent:"center"},
                // headerLeft: () => (
                //     <Image style={{width:100, height: 100 }} source={logo} />
                // )
              }}
            />
          ) : (
            // User is signed in
            <Stack.Screen name="RootDrawer" component={RootDrawer} options={{headerShown:false}} />
          )}
        </Stack.Navigator>
      </NavigationContainer>
    </AuthContext.Provider>
  );
}
